export default __webpack_public_path__ + "static/media/button-info.37e82d6e.svg";